export const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
};

export const isTablet = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /ipad|android(?!.*mobile)/i.test(userAgent);
};

export const isDesktop = () => {
  return !isMobile() && !isTablet();
}; 